
<a-select
    :id="filterElement.idForProp('filter')"
    :placeholder="placeholder"
    :options="options"
    :selected-option-ids="selectedOptionIds"
    v-model="queryIds"
    @search:finished="handleSearchFinished"
    @selected="handleSelectAll"
    @deselected="handleDeselectAll"
    bind-by-array
    multiselect
    show-checkboxes
    stay-open
></a-select>
